import React from "react";
import "./Clients.css";

const clients = [
  { id: 1, img: "/images/logo1.png", alt: "Client 1" },
  { id: 2, img: "/images/log2.png", alt: "Client 2" },
  { id: 3, img: "/images/logo3.png", alt: "Client 3" },
  { id: 4, img: "/images/logo4.png", alt: "Client 4" },
  { id: 5, img: "/images/logo5.png", alt: "Client 5" },
];

const Clients = () => {
  return (
    <section className="clients">
      <h2 className="clients-title">Our Clients</h2>
      <div className="clients-container">
        {clients.map((client) => (
          <div key={client.id} className="client-logo">
            <img src={client.img} alt={client.alt} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Clients;
